import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M10.0003 18.3334C5.39795 18.3334 1.66699 14.6025 1.66699 10.0001C1.66699 5.39771 5.39795 1.66675 10.0003 1.66675C14.6027 1.66675 18.3337 5.39771 18.3337 10.0001C18.3286 14.6004 14.6006 18.3284 10.0003 18.3334ZM3.33366 10.1434C3.37309 13.8111 6.36792 16.758 10.0358 16.7384C13.7036 16.7186 16.6666 13.7397 16.6666 10.0717C16.6666 6.40384 13.7036 3.42489 10.0358 3.40508C6.36792 3.38546 3.37309 6.33238 3.33366 10.0001V10.1434ZM11.667 14.1667H9.16699V10.8334H8.33366V9.16675H10.8337V12.5001H11.667V14.1667ZM10.8337 7.50008H9.16699V5.83342H10.8337V7.50008Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "InfoInfo"
);
